const

	CONFIG = window.CONFIG || {
		bintu: "bintu-play.nanocosmos.de",
		bintuLivestreamPlay: "rtmp://bintu-play.nanocosmos.de/play/",
		apiserver: "https://studio-api.nanostream.cloud"       // leave empty for local UI
	};

export default CONFIG;
